<template>
	<div
		class="cookies-tooltip"
		v-show="showCookiesTooltip"
	>
		<div class="container">
			<div class="cookies-tooltip__inner">
				<div class="cookies-tooltip__content">
					{{ $t('cookiesTooltip.text') }}
					<a
						class="cookies-tooltip__link"
						href="/privacy"
						target="_blank"
					>{{ $t('cookiesTooltip.link') }}</a>
				</div>

				<button
					class="cookies-tooltip__btn btn-primary dark"
					@click="hideCookiesTooltip"
				>{{ $t('cookiesTooltip.btn') }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ACCEPTED_COOKIES } from '@/service/storage'

export default {
	data() { return {
		showCookiesTooltip: !localStorage.getItem(ACCEPTED_COOKIES),

	}},

	methods: {
		hideCookiesTooltip() {
			this.showCookiesTooltip = false
			window.localStorage.setItem(ACCEPTED_COOKIES, new Date())
		},

	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.cookies-tooltip {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 9999;
	padding: 20px 0;
	pointer-events: none;

	&__inner {
		display: flex;
		flex-direction: column;
		padding: 16px;
		color: #1d2126;
		// font-size: 16px;
		background: #fff;
		border-radius: 14px;
		box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.25);
		pointer-events: auto;
	}

	&__btn {
		flex-shrink: 0;
	}

	@media (max-width: $sm) {
		&__btn {
			flex: 1 0 100%;
			width: 100%;
		}
	}

	@media (min-width: ($sm + 1)) {
		&__btn {
			align-self: center;
		}
	}

	@media (max-width: $md) {
		&__btn {
			margin-top: 16px;
		}
	}

	@media (min-width: ($md + 1)) {
		font-size: 16px;
		// font-weight: 500;

		&__inner {
			flex-direction: row;
			align-items: center;
			padding: 20px;
		}

		&__btn {
			margin-left: 40px;
		}

		@media (max-width: $lg) {
			&__btn {
				width: auto;
				margin-left: 20px;
			}
		}
	}
}
</style>
